// src/pages/Reports/BillWiseProfitLoss/billWiseProfitLossThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSalesProfitLossApi,
  getProductProfitLossApi,
} from "../../../apiservice/reports";

export const fetchBillWiseProfitLoss = createAsyncThunk(
  "billWiseProfitLoss/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        customerId: filters.customerId,
        fromDate: filters.fromDate,
        toDate: filters.toDate,
      };

      if (filters.filterType === "product_summary") {
        const res = await getProductProfitLossApi(payload);
        return {
          reportType: "product_summary",
          data: res.data || [],
          othersReport: res.others || null,
        };
      } else {
        const res = await getSalesProfitLossApi(payload);
        return {
          reportType: "bill_wise",
          data: res.data || [],
          othersReport: res.others || null,
        };
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
